import React, { memo, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { getCustomerCities, getCustomerCountries, getCustomerStates } from 'utlis/Apis/Customers_API'
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages'
import { ERROR_WHILE__NAME } from 'utlis/AppMessages/AppMessages'
import AppFormikInputInline from 'utlis/helpers/forms/AppFormikInputInline'
import AppFormikSelectInline from 'utlis/helpers/forms/AppFormikSelectInline'

function FormCustomers__Address(props) {
    const { authState, formik, userId } = props
    const [countries, setCountries] = useState([])
    const [states, setStates] = useState([])
    const [cities, setCities] = useState([])

    useEffect(() => {
        getCountries_()
    })

    const getCountries_ = () => {
        if (countries.length === 0) {
            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            getCustomerCountries(headers).then(res => {
                const countriesData = res.data

                if (countriesData.success) {
                    setCountries(countriesData.data)
                }

                if (countriesData.error) {
                    console.log('Error occured while loading admin groups!', res)
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} getCountries `, err.message)
                toast.dismiss();
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                })
            })
        }
    }

    const getStates_ = (country_id) => {
        setStates([])
        setCities([])
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getCustomerStates(headers, country_id).then(res => {
            const stateData = res.data
            if (stateData.success) {
                setStates(stateData.data)
            }

            if (stateData.error) {
                console.log('Error occured while loading states!', res)
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getStates `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            })
        })
    }

    const getCities_ = (region_id) => {
        setCities([])
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getCustomerCities(headers, region_id).then(res => {
            const cityData = res.data
            if (cityData.success) {
                setCities(cityData.data)
            }

            if (cityData.error) {
                console.log('Error occured while loading cities!', res)
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCities `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
            })
        })
    }

    return (
        <React.Fragment>
            {userId ?
                <div>
                    <AppFormikSelectInline
                        formik={formik}
                        stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                        labelName={"Address Type"}
                        isRequired={true}
                        formikFieldName={"address_type"}
                    >
                        <option disabled value="">Select Address Type</option>
                        <option value="Shipping">Shipping</option>
                        <option value="Billing">Billing</option>
                    </AppFormikSelectInline>

                    <AppFormikInputInline
                        formik={formik}
                        stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                        labelName={"First Name"}
                        isRequired={true}
                        placeholder={"First Name"}
                        formikFieldName={"shipping_first_name"}
                    />

                    <AppFormikInputInline
                        formik={formik}
                        stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                        labelName={"Middle Name"}
                        isRequired={false}
                        placeholder={"Middle Name"}
                        formikFieldName={"shipping_middle_name"}
                    />

                    <AppFormikInputInline
                        formik={formik}
                        stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                        labelName={"Last Name"}
                        isRequired={true}
                        placeholder={"Last Name"}
                        formikFieldName={"shipping_last_name"}
                    />

                    <AppFormikInputInline
                        formik={formik}
                        stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                        labelName={"Company Name"}
                        isRequired={false}
                        placeholder={"Company Name"}
                        formikFieldName={"shipping_company_name"}
                    />
                    <AppFormikInputInline
                        formik={formik}
                        stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                        labelName={"Street Address"}
                        isRequired={true}
                        placeholder={"Street Address1"}
                        formikFieldName={"shipping_address"}
                    />

                    <AppFormikInputInline
                        formik={formik}
                        stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                        labelName={"Street Address2"}
                        isRequired={false}
                        placeholder={"Street Address2"}
                        formikFieldName={"shipping_address1"}
                    />
                    <AppFormikSelectInline
                        formik={formik}
                        stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                        labelName={"Country"}
                        isRequired={true}
                        formikFieldName={"shipping_country"}
                        onChange={(country) => {
                            getStates_(country)
                            formik.setFieldValue("shipping_state", "")
                            formik.setFieldValue("shipping_city", "")
                        }}
                        disabled={countries.length === 0}
                    >
                        <option disabled value="">Select Country</option>
                        {(countries && countries.length) && countries.map(item => (
                            <option
                                key={item.country_id.toString()}
                                value={item.country_id.toString()}>{item.country}</option>
                        ))
                        }
                    </AppFormikSelectInline>

                    <AppFormikSelectInline
                        formik={formik}
                        stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                        labelName={"State/Provience"}
                        isRequired={true}
                        formikFieldName={"shipping_state"}
                        onChange={(state) => {
                            getCities_(state)
                            formik.setFieldValue("shipping_city", "")
                        }}
                        disabled={states.length === 0}
                    >
                        <option disabled value="">Select State</option>
                        {(states && states.length) && states.map(item => (
                            <option
                                key={item.region_id.toString()}
                                value={item.region_id.toString()}>{item.region}</option>
                        ))
                        }
                    </AppFormikSelectInline>

                    <AppFormikSelectInline
                        formik={formik}
                        stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                        labelName={"City"}
                        isRequired={true}
                        formikFieldName={"shipping_city"}
                        disabled={cities.length === 0}
                    >
                        <option disabled value="">Select City</option>
                        {(cities && cities.length) && cities.map(item => (
                            <option
                                key={item.city_id.toString()}
                                value={item.city_id.toString()}>{item.city}</option>
                        ))
                        }
                    </AppFormikSelectInline>

                    <AppFormikInputInline
                        formik={formik}
                        stFormClass={" st-form-with-label-left d-flex no-arrows flex-wrap align-items-center mb-1"}
                        labelName={"Zip/Postal Code"}
                        isRequired={false}
                        inputType={"number"}
                        placeholder={"ZipCode"}
                        formikFieldName={"shipping_zipcode"}
                    />

                    {/* <AppFormikInputInline
                        formik={formik}
                        stFormClass={" st-form-with-label-left no-arrows d-flex flex-wrap align-items-center mb-1"}
                        labelName={"Phone Number"}
                        inputType="phone"
                        isRequired={false}
                        placeholder={"Phone"}
                        formikFieldName={"shipping_phone"}
                    /> */}

                    <AppFormikInputInline
                        formik={formik}
                        stFormClass={" st-form-with-label-left no-arrows d-flex flex-wrap align-items-center mb-1"}
                        labelName={"Mobile"}
                        inputType="phone"
                        isRequired={true}
                        placeholder={"Mobile"}
                        formikFieldName={"shipping_mobile"}
                    />

                    <AppFormikInputInline
                        formik={formik}
                        stFormClass={" st-form-with-label-left d-flex no-arrows flex-wrap align-items-center mb-1"}
                        labelName={"Fax"}
                        isRequired={false}
                        placeholder={"Fax"}
                        inputType={"number"}
                        formikFieldName={"shipping_fax"}
                    />
                </div>
                :
                <div className="app-header-wrapper heading-md d-flex align-items-center justify-content-center customer-top-heading">
                    <p className="app-heading text-capitalize">Create Customer First</p>
                </div>
            }
        </React.Fragment>
    )
}

export default memo(FormCustomers__Address)